var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DxDataGrid',_vm._b({attrs:{"id":"complatins-data-grid","data-source":_vm.complatins,"focused-row-enabled":true,"key-expr":"id","columns":_vm.complatinsColumns}},'DxDataGrid',_vm.commonProps.dataGrid,false))
}
var staticRenderFns = []

export { render, staticRenderFns }